var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-actualite content"},[_c('div',{staticClass:"content-wrap"},[_c('PostDetails')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }